export default function QuizReducer(state, action) {
  const _qKeys = Object.keys(state.questions);

  // set the status for the current question payload
  const setStatus = () => {
    const { questionKey } = action.payload;

    let status = state.questions[questionKey].status;
    let current_status = status;

    const totalSections = Object.keys(
      state.questions[questionKey].subquestions,
    ).length;

    let currentAnswers = 0,
      savedAnswers = 0;
    Object.keys(state.questions[questionKey].subquestions).forEach((key) => {
      if (state.questions[questionKey].subquestions[key].currentAnswer)
        currentAnswers = currentAnswers + 1;
      if (state.questions[questionKey].subquestions[key].savedAnswer)
        savedAnswers = savedAnswers + 1;
    });

    if (
      savedAnswers == totalSections ||
      (savedAnswers == totalSections && totalSections > 1)
    ) {
      status = "confirm";
    } else if (
      savedAnswers == totalSections ||
      (currentAnswers == totalSections && totalSections == 1)
    )
      status = "finished";
    else if (current_status == "confirm") status = "completed";

    return status;
  };

  const restorePrevEdit = (questionKey = null) => {
    // restore
    if (
      state.questionEditStatus.value &&
      state.questionEditStatus.questionKey === questionKey
    ) {
      return {
        status: state.questionEditStatus.value,
        questionEditStatus: {
          questionKey: null,
          value: null,
        },
      };
    }
  };

  // reset all questions that are in progress (edit state) back to completed if all savedAnswers are populdated
  // when switching to summary or closing the quiz
  const resetProgressQuestions = (stateCopy) => {
    _qKeys.forEach((qKey) => {
      if (stateCopy.questions[qKey].status === "progress") {
        const sKeys = Object.keys(stateCopy.questions[qKey].subquestions);
        let saved = 0;
        sKeys.forEach((sKey) => {
          if (stateCopy.questions[qKey].subquestions[sKey].savedAnswer) saved++;
        });
        // all answers are saved for this question
        if (saved === sKeys.length)
          stateCopy.questions[qKey].status = "completed";
      }
    });
  };

  const jumpSection = (section, exclude = []) => {
    let reset = [];
    const questions = { ...state.questions };

    switch (section) {
      case 8:
        reset = [3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15];
        break;
      case 4:
        reset = [3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
        break;
      case 3:
        reset = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    }

    if (reset.length) {
      reset.forEach((r) => {
        if (!exclude.includes(r)) {
          const qKey = `question${r}`;

          if (typeof questions[qKey] !== "undefined") {
            // reset question level
            questions[qKey].status = null;
            questions[qKey].sequence = null;

            // reset subquestion level
            const sKeys = Object.keys(state.questions[qKey].subquestions);
            sKeys.forEach((sKey) => {
              questions[qKey].subquestions[sKey].currentAnswer = questions[
                qKey
              ].subquestions[sKey].savedAnswer = "";
            });
          }
        }
      });
    }
    return questions;
  };

  const goNextQuestion = (stateCopy, nextData) => {
    // if the next question is undefined, then the next question equals the current question
    if (
      typeof state.questions[`question${nextData.questionNo}`] === "undefined"
    ) {
      nextData.questionNo = state.questionNo;
    }

    // check for question logic
    if (state.questionNo >= 2) {
      const a1 =
        state.questions["question2"].subquestions["section1"].savedAnswer ===
        "Never";
      const a2 =
        state.questions["question2"].subquestions["section6"].savedAnswer ===
        "Never";

      // do manual logic checks
      // if they answer question 3 but still a1, jump
      if (state.questionNo === 3 && a1) {
        stateCopy.questions = jumpSection(8, [3]);
        nextData.questionNo = 8;
      }

      // if question no 2
      if (state.questionNo === 2) {
        if (a2) {
          stateCopy.questions = jumpSection(3);
          nextData.questionNo = 3;
        } else if (a1 && !a2) {
          stateCopy.questions = jumpSection(8);
          nextData.questionNo = 8;
        } else {
          stateCopy.questions = jumpSection(4);
          nextData.questionNo = 4;
        }
      }
    }

    // update next question status and sequence number
    let qkey = `question${nextData.questionNo}`;
    if (typeof stateCopy.questions[qkey] !== "undefined") {
      stateCopy.questions[qkey].status = "progress";
      stateCopy.questions[qkey].sequence = stateCopy.questionSequence + 1;
    }
  };

  switch (action.type) {
    // save qResponses ref
    case "qHeaderResponsesRef": {
      return { ...state, qHeaderResponsesRef: action.payload };
    }

    // scroll to the top of the qContainer
    case "qContainerScroll": {
      if (state?.qContainerref?.current !== null) {
        state.qContainerref.current.scroll({
          top: 0,
          behavior: "smooth",
        });
      }
      setTimeout(() => {
        if (state?.qHeaderResponsesRef?.current !== null) {
          state.qHeaderResponsesRef.current.scroll({
            top: state.qHeaderResponsesRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 300);
      return { ...state };
    }

    // save qContainer ref
    case "qContainer": {
      return { ...state, qContainerref: action.payload };
    }

    case "start":
      return { ...state, status: "active" };

    // store articles for recommendations
    case "windowWidth": {
      let { value: windowWidth } = action.payload;
      return {
        ...state,
        windowWidth,
      };
    }

    // store articles for recommendations
    case "setArticles": {
      let { articles } = action.payload;
      return {
        ...state,
        articles,
      };
    }

    case "continueQuiz": {
      let { questionNo, questionSection, snapshot } = action.payload;

      const stateCopy = { ...state };

      if (snapshot?.questionNo) questionNo = snapshot.questionNo;
      if (snapshot?.questionSection) questionSection = snapshot.questionSection;

      console.log("continuing with", {
        ...state,
        questions: stateCopy.questions,
        quizStatus: "progress",
        questionNo,
        questionSection,
        snapshot: {
          questionNo: null,
          questionSection: null,
        },
      });

      return {
        ...state,
        questions: stateCopy.questions,
        quizStatus: "progress",
        questionNo,
        questionSection,
        snapshot: {
          questionNo: null,
          questionSection: null,
        },
      };
    }

    // update quiz status
    case "quizStatus": {
      // reset any previous status of editing when navigation to summary
      let { value: quizStatus, snapshot } = action.payload;
      const stateCopy = { ...state };

      let questionEditStatus = { ...state.questionEditStatus };
      let prevQuizStatus = state.prevQuizStatus;
      // restore the quiz status after editing
      if (
        quizStatus !== "edit" &&
        quizStatus !== "summary" &&
        state.prevQuizStatus
      ) {
        quizStatus = state.prevQuizStatus;
        prevQuizStatus = null;
      }

      // if closing reset any progress answers to completed if they have a saved answer
      if (quizStatus == "closed" || quizStatus == "summary") {
        resetProgressQuestions(stateCopy);
      }

      if (snapshot) stateCopy.snapshot = snapshot;

      return {
        ...state,
        questions: stateCopy.questions,
        quizStatus,
        questionEditStatus,
        prevQuizStatus,
        snapshot: stateCopy.snapshot,
      };
    }

    // reset all questions in the quiz
    case "resetQuiz": {
      const stateCopy = { ...state };
      stateCopy.quizStatus = "progress";
      stateCopy.questionNo =
        stateCopy.questionSection =
        stateCopy.questionSequence =
          1;
      //const qKeys = Object.keys(stateCopy.questions);

      _qKeys.forEach((qKey) => {
        // reset question level
        stateCopy.questions[qKey].status = qKey == "question1" ? "start" : null;
        stateCopy.questions[qKey].sequence = qKey == "question1" ? 1 : null;

        // reset subquestion level
        const sKeys = Object.keys(stateCopy.questions[qKey].subquestions);
        sKeys.forEach((sKey) => {
          stateCopy.questions[qKey].subquestions[sKey].currentAnswer =
            stateCopy.questions[qKey].subquestions[sKey].savedAnswer = "";
        });
      });

      const questionEditStatus = {
        questionKey: null,
        value: null,
      };

      // reset state
      return {
        ...state,
        quizStatus: stateCopy.quizStatus,
        questionNo: stateCopy.questionNo,
        questionSection: stateCopy.questionSection,
        questions: stateCopy.questions,
        questionEditStatus,
      };
    }

    case "currentAnswer": {
      const { questionKey, sectionKey, value } = action.payload;
      const stateCopy = { ...state };

      stateCopy.questions[questionKey].subquestions[sectionKey].currentAnswer =
        value;

      const sKeys = Object.keys(state.questions[questionKey].subquestions);

      // if we are in edit mode, update the new savedAnswer with the current answer.
      // if we are answering the last question in the series, move it to a saved answer
      if (state.quizStatus === "edit" && sectionKey === sKeys.pop()) {
        stateCopy.questions[questionKey].subquestions[sectionKey].savedAnswer =
          value;
      }

      // set the question status when not editing
      if (state.quizStatus !== "edit")
        stateCopy.questions[questionKey].status = setStatus();

      return {
        ...state,
        questions: stateCopy.questions,
      };
    }

    case "saveAnswer": {
      const { questionKey, sectionKey, value } = action.payload;

      let stateCopy = { ...state };

      stateCopy.questions[questionKey].subquestions[sectionKey].savedAnswer =
        stateCopy.questions[questionKey].subquestions[
          sectionKey
        ].currentAnswer = value;

      let status = setStatus();

      // if there is a previous edit status, then restore it, otherwise try and set the status
      // to confirmed or completed etc.
      const restoreStatus = restorePrevEdit(questionKey);
      if (restoreStatus) {
        stateCopy.questionEditStatus = {
          ...restoreStatus.questionEditStatus,
        };
        status = restoreStatus.status;
      }

      let nextData = {
        questionNo: stateCopy.questionNo,
        questionSection: stateCopy.questionSection + 1,
        questionSequence: stateCopy.questionSequence,
      };

      if (
        typeof state.questions[`question${state.questionNo}`].subquestions[
          `section${nextData.questionSection}`
        ] === "undefined"
      ) {
        // this would be a single question
        nextData.questionSection = stateCopy.questionSection;

        // navigate to next question for mobile
        if (stateCopy.windowWidth < 1024 && !restoreStatus) {
          // set to confirm on last question
          status = "confirm";
          if (
            Object.keys(stateCopy.questions[questionKey].subquestions)
              .length === 1
          ) {
            // if this is the last answer, reset questionNo and questionSection if they want to redo
            if (stateCopy.questions[questionKey]?.isLast) {
              stateCopy.questions[questionKey].status = status;
              return {
                ...state,
                quizStatus: "completed",
                questions: stateCopy.questions,
                questionNo: 1,
                questionSection: 1,
              };
            } else {
              status = "completed";
              nextData.questionNo = stateCopy.questionNo + 1;
              nextData.questionSequence++;
              goNextQuestion(stateCopy, nextData);
            }
          }
        }
      }

      // finally set the current question status
      stateCopy.questions[questionKey].status = status;

      // restore the quiz status after editing
      if (state.prevQuizStatus) {
        stateCopy.quizStatus = state.prevQuizStatus;
        stateCopy.prevQuizStatus = null;
      }

      return {
        ...state,
        questionSequence: nextData.questionSequence,
        questionSection: nextData.questionSection,
        questionNo: nextData.questionNo,
        questions: stateCopy.questions,
        quizStatus: stateCopy.quizStatus,
        questionEditStatus: stateCopy.questionEditStatus,
        prevQuizStatus: stateCopy.prevQuizStatus,
      };
    }

    case "nextQuestion": {
      const { questionKey, sectionKey, value } = action.payload;

      let stateCopy = { ...state };

      stateCopy.questions[questionKey].subquestions[sectionKey].savedAnswer =
        stateCopy.questions[questionKey].subquestions[
          sectionKey
        ].currentAnswer = value;
      stateCopy.questions[questionKey].status = "completed";

      // if this is the last answer, reset questionNo and questionSection if they want to redo
      if (stateCopy.questions[questionKey]?.isLast) {
        return {
          ...state,
          quizStatus: "completed",
          questions: stateCopy.questions,
          questionNo: 1,
          questionSection: 1,
        };
      }

      // get next questionNo (and quizSectionNo - not used here)
      let nextData = {
        questionNo: state.questionNo + 1,
      };

      goNextQuestion(stateCopy, nextData);

      // restore the quiz status after editing
      if (state.prevQuizStatus) {
        stateCopy.quizStatus = state.prevQuizStatus;
        stateCopy.prevQuizStatus = null;
      }

      return {
        ...state,
        questionSequence: stateCopy.questionSequence + 1,
        questionNo: nextData.questionNo,
        questionSection: 1,
        questions: stateCopy.questions,
        quizStatus: stateCopy.quizStatus,
        prevQuizStatus: stateCopy.prevQuizStatus,
      };
    }

    case "editAnswer": {
      const { questionNo, questionSection, value, questionStatus } =
        action.payload;

      const questionKey = `question${questionNo}`;
      const sectionKey = `section${questionSection}`;

      console.log(questionKey, sectionKey);

      let stateCopy = { ...state };
      stateCopy.questions[questionKey].subquestions[sectionKey].currentAnswer =
        value;
      stateCopy.questions[questionKey].subquestions[sectionKey].savedAnswer =
        value;

      // change the status to in progress so we can edit
      stateCopy.questions[questionKey].status = "progress";

      // remember the previous quiz status for restore
      stateCopy.prevQuizStatus = state.quizStatus;

      // set quiz status
      stateCopy.quizStatus = "edit";

      return {
        ...state,
        questionNo,
        questionSection,
        questions: stateCopy.questions,
        quizStatus: stateCopy.quizStatus,
        prevQuizStatus: stateCopy.prevQuizStatus,
        questionEditStatus: {
          questionKey,
          value: questionStatus,
        },
      };
    }

    // Set quiz answers
    case "setQuizAnswers": {
      const { answers } = action.payload;
      return {
        ...state,
        quizAnswers: answers,
      };
    }

    default:
      throw Error("Action unknown");
  }
}
